import { render, staticRenderFns } from "./service_agreement.vue?vue&type=template&id=d773bb68&scoped=true&"
import script from "./service_agreement.vue?vue&type=script&lang=js&"
export * from "./service_agreement.vue?vue&type=script&lang=js&"
import style0 from "./service_agreement.vue?vue&type=style&index=0&id=d773bb68&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d773bb68",
  null
  
)

export default component.exports